// ESM shim: exposes nanoid as a named export from the CJS build.
// Required because nanoid v3 resolves to its ESM file under the "react-native"
// export condition, which webpack can't destructure correctly at runtime.
let urlAlphabet =
  'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

export function nanoid(size = 21) {
  let id = '';
  let i = size;
  while (i--) {
    id += urlAlphabet[(Math.random() * 64) | 0];
  }
  return id;
}

export function customAlphabet(alphabet, defaultSize = 21) {
  return (size = defaultSize) => {
    let id = '';
    let i = size;
    while (i--) {
      id += alphabet[(Math.random() * alphabet.length) | 0];
    }
    return id;
  };
}
